export default __webpack_public_path__ + "static/media/logout.ae33fc70.svg";